import { Box, IconButton, TableHead as MUITableHead, TableRow, Checkbox } from '@mui/material';

import { StyledCheckboxCell, StyledTableCell } from './table-styles';

import FilterIcon from '@mui/icons-material/Filter';
import SortAtoZ from '@mui/icons-material/SortByAlpha';
import SortZtoA from '@mui/icons-material/SortByAlphaOutlined';
import { TableHeadProps } from 'src/types/table';

export const TableHead = ({
  columns,
  onHeaderClick,
  onSort,
  sortDirection,
  sortColumn,
  showCheckbox,
  onSelectAll,
  isAllSelected,
  isPartiallySelected,
}: TableHeadProps): JSX.Element => <MUITableHead>
    <TableRow>
      {showCheckbox && (
        <StyledCheckboxCell>
          <Checkbox
            color="primary"
            checked={isAllSelected}
            indeterminate={isPartiallySelected}
            onChange={(e) => {
              e.stopPropagation();
              onSelectAll?.(e);
            }}
          />
        </StyledCheckboxCell>
      )}
      {columns.map((column) => (
        <StyledTableCell
          key={column.id}
          onClick={() => column.sortable && onSort(column.id)}
          sx={{
            cursor: column.sortable ? 'pointer' : 'default',
            ...(column.width != null
              ? {
                  width: column.width,
                  minWidth: column.width,
                  maxWidth: column.width,
                }
              : { maxWidth: 'fit-content' }),
          }}
          sortDirection={sortColumn === column?.id && sortDirection}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              // width: 'auto',
            }}>
            {column.label}
            {(column.sortable || column.filterable) && (
              <Box className="actions">
                {column.sortable && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {sortColumn === column.id && sortDirection === 'desc' ? (
                      <SortZtoA />
                    ) : (
                      <SortAtoZ />
                    )}
                  </Box>
                )}
                {column.filterable && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onHeaderClick(e, column.id);
                    }}>
                    <FilterIcon />
                  </IconButton>
                )}
              </Box>
            )}
          </Box>
        </StyledTableCell>
      ))}
    </TableRow>
  </MUITableHead>

